<script>
export default {
    name: 'IlluMedal',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-medal"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M33.023 9.81a1.495 1.495 0 00-2.112.065l-3.707 3.91a2.5 2.5 0 01-2.393.712l-5.234-1.244c-.404-.077-.8.015-1.118.227a1.495 1.495 0 00-.637.955l-1.079 5.445a2.5 2.5 0 01-1.59 1.86l-5.103 1.874a1.493 1.493 0 00-.832.785c-.158.35-.182.76-.036 1.147l2.107 5.57a2.5 2.5 0 010 1.769l-2.113 5.587a1.495 1.495 0 00.893 1.92l5.084 1.868a2.5 2.5 0 011.59 1.86l1.093 5.51c.098.398.347.721.671.921.327.201.73.278 1.134.182l5.17-1.23a2.5 2.5 0 012.393.712l3.773 3.975a1.495 1.495 0 002.112-.065l3.707-3.91a2.5 2.5 0 012.393-.712l5.234 1.244c.404.077.8-.015 1.118-.227.319-.213.556-.548.637-.955l1.079-5.445a2.5 2.5 0 011.59-1.86l5.103-1.874c.383-.145.674-.435.832-.785.158-.35.182-.76.036-1.147l-2.107-5.57a2.5 2.5 0 010-1.769l2.113-5.587a1.493 1.493 0 00-.048-1.142 1.495 1.495 0 00-.844-.778l-5.085-1.868a2.5 2.5 0 01-1.59-1.86l-1.093-5.51a1.495 1.495 0 00-.671-.921 1.495 1.495 0 00-1.134-.182l-5.17 1.23a2.5 2.5 0 01-2.393-.712L33.023 9.81z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <circle
                :stroke="secondaryColor"
                class="secondary-color"
                cx="32"
                cy="32"
                r="13.5"
            />
            <path
                d="M39.412 25.625L41 27.213l-9.552 9.551.023.023-1.589 1.588L23 31.493l1.588-1.588 5.271 5.271 9.553-9.551z"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
